export default __webpack_public_path__ + "static/media/flag-norfolk-island.3e36f6fa.svg";